@if (isOpen) {
    <app-product-advice
        [questionSet]="questions"
        [initialValues]="state.advice"
        (answersUpdated)="evaluateRecommendation($event)"
        (submit)="submit()"
    />
    @if (showAdvice()) {
        <app-product-advice-result-box
            [shouldChangeTheftCoverage]="suggestTheftCoverageChange()"
            [shouldChangeDeductible]="suggestDeductibleChange()"
            [recommendedPrice]="recommendedPrice()"
            (applyAdvice)="setAdviceDecisionAndSubmit($event)"
        />
    }
}
